import { render, staticRenderFns } from "./ChangeUserPhoneNumberModalComponent.vue?vue&type=template&id=363fb108"
import script from "./ChangeUserPhoneNumberModalComponent.vue?vue&type=script&lang=js"
export * from "./ChangeUserPhoneNumberModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports